import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  cocktailList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto 0',
    padding: '0 12px',

    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  noProductsMessage: {
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font18PX,
    color: theme.colors.light.freshPowder,
  },
}));
